<template>
    <div v-if="studies.length > 0" class="completed-count-info">
        <span :class="['completed-count-info__icon', type, getIconClass]"/>
        <span class="completed-count-info__count-text" v-html="text"></span>
        <span class="completed-count-info__amount">{{ studies.length }}</span>
    </div>
</template>

<script>

    export default {
        name: 'studies-count-info',
        props: {
            studies: Array,
            text: String,
            type: {
                type: String,
                validator: (prop) => ['completed', 'uncompleted'].includes(prop),
            }
        },
        computed: {
            getIconClass () {
                return this.type === 'completed' ? 'icon-checkmark' : 'icon-hour-glass'
            }
        }
    }
</script>

<style lang="scss" scoped>
    .completed-count-info {
        display: flex;
        position: relative;
        background-color: $white;
        padding: 3px 12px;
        height: 44px;
        border-radius: 5px;
        width: max-content;
        justify-content: center;
        gap: 6px;
        align-items: center;
        font-size: 1.6rem;
        border: 1px solid $lavender;

        [class*="desktop"] & {
            min-width: 250px;
        }

        [class*="mobile_sm"] & {
            height: 40px;
        }

        [class*="mobile"] & {
            font-size: 1.6rem;
        }

        &__icon {
            color: $lavender;
            font-size: 1.6rem;

            &.uncompleted {
                color: $lavender;
            }
        }
    }
</style>
